import Vue from "vue";
import VueQuillEditor from "vue-quill-editor";

// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

Vue.use(VueQuillEditor /* { default global options } */);

import { Quill } from "vue-quill-editor";
const sizeStyle = Quill.import("attributors/style/size");
sizeStyle.whitelist = ["12px", "14px", "18px", "20px", "24px", "30px"];
console.log({ sizeStyle });
Quill.register(sizeStyle, true);
